<template>
  <div class="page-content">
    <md-whiteframe md-tag="md-toolbar" md-elevation="1" class="main-header topnav">
      <md-button class="md-icon-button nav-trigger" @click="toggleSidenav">
        <md-icon>menu</md-icon>
      </md-button>

      <div class="md-title">{{ pageTitle }}</div>
      <h2 align="center" class="md-title" style="flex: 1" id="title"> 
        {{ softwareTitle }}  
      <!-- <small><span class="smaller">Beta 1</span></small> -->
      </h2>

      <md-menu md-size="3" ref="langCard">
        <md-button id="langButton" class="md-button md-sqlang" md-menu-trigger>
          {{ local }}
          <md-icon>language</md-icon>
        </md-button>

        <md-menu-content  class="langMenu">
          <md-menu-item md-active @click.native="setLocale('es')">
            <md-radio v-model="local" id="my-test1" name="idiomaGroup" md-value="es">{{ 'global.~ESPANOL~' | translate }}</md-radio>
          </md-menu-item>

          <md-menu-item @click.native="setLocale('en')">
            <md-radio v-model="local" id="my-test2" name="idiomaGroup" md-value="en">{{ 'global.~INGLES~' | translate }}</md-radio>
          </md-menu-item>

                    <md-menu-item @click.native="setLocale('pt')">
            <md-radio v-model="local" id="my-test3" name="idiomaGroup" md-value="pt">{{ 'global.~PORTUGUES~' | translate }}</md-radio>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
      
      <md-button @click.native="activeHelp" class="md-icon-button help-button">
        <md-icon :class="{ 'custom-color-active' :  isActiveHelp,  'custom-color' :  !isActiveHelp }">live_help</md-icon>
        <md-tooltip v-if="isActiveHelp" md-direction="bottom">
          {{ 'global.~DESACTIVAR~' | translate }}
        </md-tooltip>
        <md-tooltip v-else md-direction="bottom">
          {{ 'global.~ACTIVAR~' | translate }}
        </md-tooltip>
      </md-button>
      
    </md-whiteframe>

    <slot></slot>

    <main-footer :name="softwareTitle"></main-footer>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import split from 'lodash/split'
import MainFooter from '@/components/main-footer'

export default {
  props: {
    pageTitle: String
  },
  components: {
    MainFooter
  },
  data () {
    return {
      local: this.$i18n.locale()
    }
  },
  computed: {
    versionNumber: function () {
      return split(' $Id: f3c82760b8987501919456117e4518bd5e5a18d5 $ ', ' ')[2].slice(-4)
    },
    isActiveHelp () {
      return this.$store.state.tour.activeHelp
    },
    ...mapState({
      currentOrgId: state => state.authentication.currentOrgId,
      organizations: state => state.authentication.currentUser.data.organizations
    }),
    ...mapGetters({
      softwareTitle: 'currentSoftwareTitle'
    })
  },
  mounted () {
    document.title = this.pageTitle + ' - ' + this.softwareTitle
    this.$events.$on('open-lang-card', value => {
      this.$refs.langCard.open()
    })
    this.$events.$on('close-lang-card', value => {
      this.$refs.langCard.close()
    })
  },
  beforeDestroy () {
    this.$events.$off('open-lang-card')
    this.$events.$off('close-lang-card')
  },
  methods: {
    toggleSidenav () {
      this.$events.$emit('toggleSidenav')
    },
    setLocale (locale) {
      this.$i18n.set(locale)
      this.local = locale
      this.$validator.localize(locale)
    },
    getLocale (locale) {
      if (this.$i18n.locale() === locale) { return true } else { return false }
    },
    activeHelp () {
      if (this.$store.state.tour.activeHelp === true) {
        this.$events.$emit('active-help', false)
      } else {
        this.$events.$emit('active-help', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    min-height: 100%;
    max-height: 100%;
    flex: 1;
    display: flex;
    flex-flow: column
  }
  .main-header {
    z-index: 2;
    color: #fff !important;
  }
  .nav-trigger {
    @media (min-width: 1281px) {
      display: none;
    }
  }
  .md-title {
    // flex: 1;
    @media (min-width: 1281px) {
      margin-left: 8px;
    }
  }
  .github {
    @media (max-width: 480px) {
      display: none;
    }
  }

  .smaller {
    font-size:12px;
    color: #ff9922;
  }

  .custom-color {
    color: #9ebfdd;
  }

  .custom-color-active {
    color: #ffffff;
  }

  .md-sqlang {
    min-width: 30px !important;
    padding: 0 10px !important;
    margin: 2px 0px !important;
  }

</style>



// WEBPACK FOOTER //
// page-content.vue?0e1a4925